var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.222,
    height: 32,
    viewBox: "0 0 29.222 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_11",
    "data-name": "Raggruppa 11",
    transform: "translate(-990.725 -263)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Linea_1",
    "data-name": "Linea 1",
    d: "M27.222,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H27.222a1,1,0,0,1,1,1A1,1,0,0,1,27.222,1Z",
    transform: "translate(991.725 289.333)",
    fill: "#2b2c2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_339",
    "data-name": "Tracciato 339",
    d: "M74.6,203.748a5.673,5.673,0,0,1-5.667-5.667,1,1,0,0,1,2,0,3.667,3.667,0,1,0,7.333,0,1,1,0,0,1,2,0A5.673,5.673,0,0,1,74.6,203.748Z",
    transform: "translate(930.732 91.252)",
    fill: "#2b2c2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_340",
    "data-name": "Tracciato 340",
    d: "M43.71,39.972a1,1,0,0,1-1-1V26.417a9.778,9.778,0,0,0-19.556,0V38.972a1,1,0,0,1-2,0V26.417a11.778,11.778,0,0,1,23.556,0V38.972A1,1,0,0,1,43.71,39.972Z",
    transform: "translate(972.404 250.361)",
    fill: "#2b2c2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Linea_2",
    "data-name": "Linea 2",
    d: "M0,3A1,1,0,0,1-1,2V0A1,1,0,0,1,0-1,1,1,0,0,1,1,0V2A1,1,0,0,1,0,3Z",
    transform: "translate(1005.336 264)",
    fill: "#2b2c2e"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification-icon.7787a89c0fd2fc150fee267253fba18c.svg";
export { ForwardRef as ReactComponent };